import { render } from "./TabApi.vue?vue&type=template&id=7620cc52&scoped=true"
import script from "./TabApi.vue?vue&type=script&lang=js"
export * from "./TabApi.vue?vue&type=script&lang=js"

import "./TabApi.vue?vue&type=style&index=0&id=7620cc52&scoped=true&lang=css"
import "./TabApi.vue?vue&type=style&index=1&id=7620cc52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7620cc52"]])

export default __exports__